import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Brain, Heart, Lightbulb, TrendingUp, Users } from "lucide-react";
const pillars = [{
  title: "Small-group motorbike journeys",
  hook: "A premium curated journey for up to 6 riders. Reserve Your Seat now.",
  icon: Users,
  path: "https://frontiernorthvietnam.com/booking/"
}, {
  title: "Professional Riders – Easy Rider experience",
  hook: "Sit back and absorb the landscape with expert local guides. A premium curated journey through the mountains.",
  icon: TrendingUp,
  path: "https://frontiernorthvietnam.com/our-journeys/"
}, {
  title: "The Quiet Frontier",
  hook: "No party tours. We focus on a calm, professional atmosphere. Reserve Your Seat for a soulful adventure.",
  icon: Heart,
  path: "https://frontiernorthvietnam.com/booking/"
}, {
  title: "Ha Giang Loop journeys",
  hook: "Explore the heart of the Ha Giang Loop on paths less traveled. A premium curated journey into the wild.",
  icon: Brain,
  path: "https://frontiernorthvietnam.com/our-journeys/"
}, {
  title: "Boutique Premium Stays",
  hook: "Rest in hand‑picked accommodations that reflect local character. Reserve Your Seat for ultimate comfort.",
  icon: Lightbulb,
  path: "https://frontiernorthvietnam.com/booking/"
}];
export default function CorePillarsOfTheMind() {
  return <section data-section-id="224717" id="the-frontier-philosophy" className="dark bg-primary text-foreground py-20 px-4 md:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center lg:mb-16">
          <h2 className="font-serif text-4xl font-light tracking-tight sm:text-5xl text-white">
            Small-group motorbike journeys – The Frontier Philosophy
          </h2>
          <p className="font-default text-white/80 mx-auto mt-4 max-w-2xl text-lg">
            Experience the Ha Giang Loop with our signature Easy Rider experience. Enjoy slow travel, quiet mountains, and the luxury of space.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
          {pillars.map((pillar, i) => <Link key={pillar.title} to={pillar.path} className="group block h-full outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-none" data-index={i}>
              <Card className="bg-white/5 border-white/10 hover:bg-white/10 flex h-full flex-col transition-colors duration-500 rounded-none shadow-none">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-none bg-transparent">
                    <pillar.icon className="text-white h-6 w-6 stroke-[1px]" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-serif text-white text-xl font-medium transition-colors group-hover:text-white/90">
                    {pillar.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="mt-auto pt-0">
                  <p className="font-default text-white/70 text-sm leading-relaxed">
                    {pillar.hook}
                  </p>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}